<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <SurveyTabLinks />
                    <!-- <div class="flex mt-2">
                        <ProductFinder
                            business_type="restaurant"
                            :business_id="$route.params.id"
                            @select="selectDish"
                        />
                    </div> -->
                    <div class="flex flex-row-reverse">
                        <CButton
                            color="primary"
                            class="mt-2"
                            @click="create"
                        >Создать</CButton>
                    </div>
                    <CRow class="pl-3 pb-3" />
                    <CRow>
                        <CCol>
                            <table class="table">
                                <thead>
                                    <th></th>
                                    <th>Вопрос</th>
                                </thead>
                                <component
                                    :is="'draggable'"
                                    v-model="questions"
                                    tag="tbody">
                                    <tr v-for="item in questions" :key="item.id">
                                        <td class="p-1">
                                            <CIcon
                                                :height="24"
                                                :content="$options.icons.cilCursorMove"
                                                class="cursor-pointer"
                                            />
                                        </td>
                                        <td class="p-1">
                                            <CLink
                                                :to="`/surveys/${entity.id}/questions/${item.id}`"
                                            >{{ item.title }}</CLink>
                                        </td>
                                    </tr>
                                </component>
                            </table>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="save"
                    >Сохранить расположение</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';
    import SurveyTabLinks from '@/components/surveys/SurveyTabLinks';

    export default {
        name: 'RestaurantDishes',

        components: {
            SurveyTabLinks,
            draggable,
        },

        data() {
            return {
                entity: {},
                questions: [],
            };
        },
        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        },
        async mounted() {
            const id = this.$route.params.id;
            try {
                const { data } = await Vue.axios.get('/surveys/' + id);
                this.entity = data;
                this.questions = data.questions;
            }
            catch (e) {
                this.$root.$emit('showError', 'Ошибка загрузки данных.');   
            }
        },

        icons: {
            cilCursorMove,
        },

        methods: {
            save() {
                const reorder = [];
                let index = 0;
                this.questions.forEach(item => {
                    reorder.push({
                        id: item.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post('/surveys/' + this.entity.id + '/questions/reorder', { reorder: reorder })
                    .then(() => {
                        this.$router.push('/surveys/' + this.entity.id);
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            update(item) {
                Vue.axios.put('/surveys/' + this.entity.id + '/questions/' + item.id, item)
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            create() {
                this.$router.push(
                    '/surveys/' + this.entity.id + '/questions/create'
                );
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
        },
    };
</script>
<style lang="scss" scoped>
.table {
    tr {
        td {
            padding: 0 .2rem;

            &:nth-child(2) {
                max-width: 30vw;
            }
        }
    }
}
</style>
